import { Link } from "react-router-dom";
import { BOOKING_URL, CONTACT, STUDIO } from "../data/content";
import { useT } from "../i18n/LanguageContext";

export default function Footer() {
  const { t } = useT();

  return (
    <footer data-testid="site-footer" className="relative bg-black border-t border-white/5 py-16">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="text-[#D4AF37] font-serif-display text-3xl">N</span>
              <span className="font-serif-display text-xl text-white">{STUDIO.name}</span>
            </div>
            <p className="text-white/45 text-sm leading-relaxed max-w-md">{t("footer.tagline")}</p>
          </div>

          <div>
            <p className="overline mb-4">{t("footer.studio_label")}</p>
            <p className="text-white/70 text-sm leading-relaxed">
              {CONTACT.address}
              <br />
              <span className="text-white/45 text-xs uppercase tracking-widest">{t("footer.beauty_label")}</span>
              <br />
              <a
                href={`tel:${CONTACT.phoneLink}`}
                className="hover:text-[#D4AF37] transition-colors"
                data-testid="footer-phone"
              >
                {CONTACT.phone}
              </a>
              <br />
              <span className="text-white/45 text-xs uppercase tracking-widest mt-2 inline-block">
                {t("footer.hair_label")}
              </span>
              <br />
              <a
                href={`tel:${CONTACT.hairPhoneLink}`}
                className="hover:text-[#D4AF37] transition-colors"
                data-testid="footer-hair-phone"
              >
                {CONTACT.hairPhone}
              </a>{" "}·{" "}
              <a
                href={CONTACT.hairWhatsAppLink}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#D4AF37] transition-colors"
                data-testid="footer-hair-whatsapp"
              >
                WhatsApp
              </a>
            </p>
          </div>

          <div>
            <p className="overline mb-4">{t("footer.book_overline")}</p>
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-book-btn"
              className="btn-gold"
            >
              {t("footer.book_cta")}
            </a>
          </div>
        </div>

        <div className="gold-line" />

        <div className="mt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-6 text-[11px] tracking-[0.2em] uppercase text-white/40">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} {STUDIO.name} · Frankfurt
          </p>
          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/impressum" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-impressum-link">
              {t("footer.impressum")}
            </Link>
            <Link to="/datenschutz" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-datenschutz-link">
              {t("footer.privacy")}
            </Link>
            <Link to="/agb" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-agb-link">
              {t("footer.terms")}
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
